import type { VmTask } from '../api/types.js';

/**
 * The start needs the disks' passphrase. The backend probes the disks for
 * LUKS when the start launches, after it was accepted, so the failed task
 * says so (error_code PASSPHRASE_REQUIRED) when no passphrase is stored.
 */
export function needsPassphrase(task: VmTask | null): boolean {
  return task?.state === 'failed' && task.error_code === 'PASSPHRASE_REQUIRED';
}
